module.exports = __webpack_public_path__ + "static/media/trophyIcon.a528f993.svg";